import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const FSSAIRegistrationLicense = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        FSSAI Registration/License
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        The FSSAI Registration or License, issued under the Food Safety and
        Standards Authority of India (FSSAI), is a mandatory requirement for all
        food-related businesses before commencing operations, ensuring
        compliance with food safety standards.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Regulatory Overview */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Regulatory Overview
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The Food Safety and Standards Authority of India (FSSAI), an
            autonomous body under the Ministry of Health and Family Welfare,
            collaborates with State Food Authorities to enforce food safety laws
            and establish science-based standards for food production and
            distribution.
          </p>

          {/* Entity Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Entity Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            All food-related businesses, including manufacturers, traders,
            restaurants, small eateries, grocery shops, importers, exporters,
            home-based food ventures, dairy farms, and processors, must obtain an
            FSSAI license or registration. The 14-digit license number reflects
            the producer’s permit details.
          </p>

          {/* Licensing Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Licensing Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            FSSAI licenses are classified into three main categories: Basic
            License (for businesses with an annual turnover up to ₹12 lakhs),
            State License (for turnover between ₹12 lakhs and ₹20 crores), and
            Central License (for turnover exceeding ₹20 crores). Small food
            vendors and petty retailers only need FSSAI registration instead of a
            full license.
          </p>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ol
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Select the type of food business.</li>
            <li>Identify the appropriate food category.</li>
            <li>Choose the relevant license type (Basic, State, or Central).</li>
            <li>Submit required documentation.</li>
            <li>Receive the issued certificate upon approval.</li>
          </ol>

          {/* Documentation for Registration */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Documentation for Registration
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For petty food retailers seeking FSSAI registration, required
            documents include:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Photograph of the Food Business Operator (FBO).</li>
            <li>
              Identity proof (e.g., Ration Card, Voter ID, PAN Card, Driving
              License, Passport, Aadhar Card, Senior Citizen Card, or Department
              Issued ID).
            </li>
            <li>
              Supporting documents (if applicable): NOC from Municipality or
              Panchayat, Health NOC.
            </li>
          </ul>

          {/* Licensing Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Licensing Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For Basic FSSAI Registration:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>FSSAI Declaration.</li>
            <li>Photo identity proof of FBO.</li>
            <li>
              Proof of premises possession (e.g., rent agreement, MOA, AOA,
              Partnership Deed).
            </li>
            <li>Category of food products.</li>
            <li>Food safety management system plan.</li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For State License:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              Details of partners, directors, or proprietors with addresses and
              contact information.
            </li>
            <li>Passport-sized photograph of the applicant.</li>
            <li>Identification and address proof.</li>
            <li>PAN Card.</li>
            <li>
              Property papers or rent agreement with NOC from landlord.
            </li>
            <li>Source of raw materials.</li>
            <li>Completed and signed Form.</li>
            <li>List of equipment and machinery.</li>
            <li>Municipality NOC.</li>
            <li>Food category and product details.</li>
            <li>E-code from DGFT (if applicable).</li>
            <li>Form IX nomination (for companies).</li>
            <li>Authorization letter.</li>
            <li>Food safety management plan certificate.</li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For Central License:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Completed and signed Form B.</li>
            <li>Premises layout plan with measurements.</li>
            <li>
              For companies: List of directors with MOA, AOA, and COI.
            </li>
            <li>For partnerships: List of partners with partnership deed.</li>
            <li>For cooperatives: List of members.</li>
            <li>For trusts: Trust deed and trustee records.</li>
            <li>
              Address proof (e.g., electricity bill, rent agreement, registry).
            </li>
            <li>Food safety management plan.</li>
            <li>List of equipment and machinery.</li>
            <li>Source of raw materials and locations.</li>
            <li>Municipality NOC.</li>
            <li>Tourism certificate (for hotels).</li>
            <li>IE code from DGFT (if applicable).</li>
          </ul>

          {/* Petty Operator Definition */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Petty Operator Definition
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Petty food business operators include individuals manufacturing or
            selling food articles, retailers, hawkers, vendors, stallholders, or
            those distributing food at religious/social gatherings (excluding
            caterers), with a turnover not exceeding Rs. 12 lakhs and specific
            production limits (e.g., 100 kg/liter per day, 500 liters of milk, or
            limited slaughtering capacity).
          </p>

          {/* License Validity */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            License Validity
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            FSSAI licenses are valid from 1 to 5 years based on the FBO’s
            request, with higher fees corresponding to longer validity periods.
            Registration certificates must be prominently displayed at the
            business premises.
          </p>

          {/* Legal Consequences */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Legal Consequences
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Operating without an FSSAI license is punishable by up to six months
            imprisonment and a fine of up to Rs. 5 lakhs. False advertising
            regarding food quality or composition can incur a penalty of up to
            Rs. 10 lakhs.
          </p>

          {/* Compliance Monitoring */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Monitoring
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            FSSAI and State Authorities conduct inspections to ensure
            compliance. Non-compliance with licensing or advertising regulations
            may lead to legal action and penalties as stipulated under the Act.
          </p>

          {/* Concluding Insights */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Insights
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The FSSAI registration and licensing framework is essential for
            regulating India’s food industry, ensuring safety and quality.
            Businesses must adhere to the specified processes and documentation
            to avoid legal repercussions.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FSSAIRegistrationLicense;